import { Dayjs } from 'dayjs'
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs'
import generatePicker from 'antd/lib/date-picker/generatePicker'

const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig)

export const TimePicker = DatePicker.TimePicker
export const TimeRangePicker = DatePicker.RangePicker

export default DatePicker
